// extracted by mini-css-extract-plugin
module.exports = {"icon":"QuestionIcon_icon__2lzi8"};